module.exports = __webpack_public_path__ + "media/photo/abouts_solutions_man-cf10f32c.jpg";